'use strict';

const { pubdb } = Function('return this')();
const {
    $, next_tick, trim, echo, ajax_post, path_root, confirm, display_list, map,
    display_when_ready, ajax_success_handler, kb_ev_enter,
} = pubdb;


var do_scroll_into_view = false;

$(function () {
    $('#userpage-form').submit(function () {
        return false;
    });

    function add_item () {
        do_scroll_into_view = true;
        var name = trim(add_field.val());
        if (!name) {
            echo('warn', 'Bitte geben Sie einen Namen für Ihre neue Publikationsliste an.');
            return;
        }
        var data = {
            name: name,
            csrf_token: pubdb.csrf_token,
        };
        ajax_post(path_root + '/userpage/new/', data, list_added, req_error);
    }

    var add_field = $('#pubdb_data li:first input');
    $('#pubdb_data button').click(function (ev) {
        ev.preventDefault();
        next_tick(add_item);
    });
    add_field.keypress(function (ev) {
        if (kb_ev_enter(ev)) {
            ev.preventDefault();
            next_tick(add_item);
        }
    });
});

function req_error (data, err, xhr) {
    echo('warn', 'Fehler (' + data.statusText + ') - bitte versuchen Sie es erneut');
}

function list_added (data) {
    if (!ajax_success_handler(data)) {
        return;
    } else if(!data.page || !data.page.length) {
        echo('warn', 'Interner Fehler: Es wurde keine neue Publikationsliste angelegt.');
        return;
    }

    var page = data.page[0];

    function list_deleted (data) {
        if (!ajax_success_handler(data)) {
            return;
        } else if(!data.page || !data.page.length) {
            echo('warn', 'Interner Fehler: Es wurde keine Publikationsliste gelöscht.');
            return;
        }
        echo('confirm', 'Ihre Publikationsliste mit dem „' + data.page[0].name + '“ wurde erfolgreich gelöscht.')
        list_element.hide('slow', function () {
            list_element.detach();
        });
    }

    function doDelete () {
        var data = {
            id: page.id,
            name: page.name,
            csrf_token: $('[name=csrf_token]').val()
        };
        ajax_post(path_root + '/userpage/' + page.id + '/delete/', data, list_deleted, req_error);
    }

    function onDelete () {
        confirm('Wirklich löschen?',
                'Wollen Sie Ihre Publikationsliste mit dem Namen „' + page.name + '“ wirklich löschen? ' +
                'Das Löschen kann nicht rückgängig gemacht werden. ' +
                'Diese Liste hat derzeit ' + ({
                    0: 'keine Einträge',
                    1: 'einen Eintrag'
                }[page.pubs.length] || page.pubs.length + ' Einträge') + '.',
                [['nicht löschen'], ['löschen („' + page.name + '“)', doDelete]]);
        return false;
    }

    function onShowList () {
        var self = $(this).parent().removeAttr('title').css({
            cursor: 'auto'
        }).click(function () {
            return false;
        }).hide();

        var action_extras = display_list(page.pubs, pubs_dest);

        function req_error (data, err, xhr) {
            echo('warn', 'Fehler (' + data.statusText + ') - bitte versuchen Sie es erneut');
        }

        function del_success (resp) {
            if (!ajax_success_handler(resp)) {
                return;
            }
            const { data } = resp;

            const { deleted } = data;
            if (!deleted) {
                return;
            }

            const { length } = deleted;
            if (!length) {
                return;
            }

            echo('confirm', deleted.length + ' Publikationen wurden aus dem Publikationsverzeichnis „' + page.name + '“ entfernt.');
            for (let del_index = 0; del_index < length; ++del_index) {
                const pub_id = deleted[del_index];

                for (let pub_index = 0, { pubs } = page, pubs_length = pubs.length; pub_index < pubs_length; ++pub_index) {
                    if (pub_id === pubs[pub_index].id) {
                        pubs.splice(pub_index, pub_index+1);
                        break;
                    }
                }

                $('li[data-pubid="' + pub_id + '"]', action_extras.dest).css({
                    color: '#666'
                }).slideUp('slow').find('input[type=checkbox]').prop('checked', false);
            }
        }

        $([
            $('<h4/>', { text: 'Publikationsverzeichnis bearbeiten:' }),
            $('<label/>', {
                append: [
                    $('<input/>', {
                        type: 'radio',
                        value: 'del_from_list',
                        name: 'export-action'
                    }),
                    $('<span/>', { text: 'Von dieser Liste entfernen' })
                ]
            })
        ]).insertAfter($('.PD_actions form :radio[name="export-action"]:last', action_extras.dest).parent('label'));

        action_extras.data_cb = function (pubs_list, selected_export, selected_scope) {
            if (selected_export[0] !== 'del_from_list') {
                return;
            }
            if (pubs_list.type === 'pubs') {
                var pub_ids = map(pubs_list, p => p.id);
            } else {
                var pub_ids = [].slice.call(pubs_list, 0);
            }
            ajax_post(path_root + '/userpage/' + page.id + '/delete/pubs/', {
               csrf_token: pubdb.csrf_token,
               pub_ids: pub_ids
            }, del_success, req_error);
        };
    }

    function onFocusUrl () {
        $(this).select();
    }

    function includeLabel (text, value) {
        return $('<label/>', { append: [
            $('<span/>', { text: text }),
            $('<input/>', {
                type: 'text',
                value: value,
                readonly: true,
                on: {
                    focus: onFocusUrl,
                    click: onFocusUrl
                },
            })
        ]});
    }

    function includeButton (where, what) {
        return includeLabel('Quelltext zum Einbinden ' + where,
                            '<div><script src="' + path_root + '/userpage/' + page.id + '/embed/' +
                                                   page.secret + '/' + what + '/" type="text/javascript"></script>Lädt …</div>');
    }

    var pubs_dest = $('<div/>');
    var list_element = $('<li/>', {
        append: [
            $('<button/>', {
                title: 'Diese Publikationsliste löschen.',
                text: '\u2212',
                css: {
                    'background-color': '#7D1111',
                    'border-color': '#7D1111'
                },
                on: {
                    click: onDelete
                }
            }),
            $('<div/>', {
                'class': 'main_form',
                append: [
                    $('<h3/>', {
                        text: page.name,
                        style: 'font-size: 120%; font-weight: bold; margin-top: 0;'
                    }),
                    includeLabel(
                        'Adresse zum Eintragen bei im Feld „Publikationen (iFrame-URL)“:',
                        path_root + '/pub/search/?start=0&count=1000&userpage_id=' + page.id + '&userpage_secret=' + page.secret + '&renderer=iframe',
                    ),
                    // includeButton('auf Mitarbeiterseite im CMS: (als „Hauptinhalt!“)', 'mitarbeiterseite'),
                    // includeButton('auf anderen Seiten im CMS:', 'cms'),
                    $('<div/>', {
                        append: [
                            $('<h4/>', {
                                style: 'font-size: 110%; margin-top: 0; color: black; text-align: center;',
                                append: $('<label/>', {
                                    css: {
                                        cursor: 'pointer'
                                    },
                                    title: 'ausklappen',
                                    append: page.pubs.length
                                            ?   [
                                                   $('<button/>', {
                                                        text: '+',
                                                        one: {
                                                            click: onShowList
                                                        },
                                                        style: 'padding: 0; text-align: center; width: 24px; height: 24px;'
                                                    }),
                                                    $('<span/>', { text: '\xA0Enthaltene Publikationen (' + page.pubs.length + ')' })
                                                ]
                                            :   $('<span/>', { text: 'Sie haben zu dieser Liste noch keine Publikationen hinzugefügt.' })
                                })
                            }),
                            pubs_dest
                        ]
                    })
                ]
            })
        ],
        insertAfter: $('#pubdb_data li:first')
    });

    if (page.pubs.length && page.pubs.length <= 5) {
        $('button:eq(1)', list_element).click();
    }
    if (do_scroll_into_view) {
        list_element.get(0).scrollIntoView(true);
    }
}

function lists_loaded (data) {
    if (!ajax_success_handler(data)) {
        return;
    }

    $('#pubdb_data li:nth-of-type(2)').remove();
    for (var i = 0; i < data.pages.length; ++i) {
        list_added({
            success: true,
            page: [data.pages[i]]
        });
    }
}

ajax_post(
    path_root + '/userpage/list/',
    {},
    display_when_ready(lists_loaded),
    display_when_ready(req_error),
);
